import React from 'react'
import separador from "../assets/separator-white.png";

const Separator = ({bg = "white"}) => {
    return (
        <div className="relative w-[168px] h-[26px] mx-auto"><img src={separador} fill alt=""/></div>
    )
}

export default Separator